// tslint:disable: no-duplicate-imports
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";

import { APP_INITIALIZER, LOCALE_ID, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

// #region default language
import { default as ngLang } from "@angular/common/locales/en";
import { DELON_LOCALE, en_US as delonLang } from "@delon/theme";
import { default as dateLang } from "date-fns/locale/en-US";
import {
  NZ_DATE_LOCALE,
  NZ_I18N,
  en_US as zorroLang,
} from "ng-zorro-antd/i18n";
const LANG = {
  abbr: "en",
  ng: ngLang,
  zorro: zorroLang,
  date: dateLang,
  delon: delonLang,
};
import localeNg from "@angular/common/locales/en-NG";

// register angular
import { LocationStrategy, PathLocationStrategy, registerLocaleData } from "@angular/common";
registerLocaleData(LANG.ng, LANG.abbr);
registerLocaleData(localeNg);
const LANG_PROVIDES = [
  // { provide: LOCALE_ID, useValue: LANG.abbr },
  { provide: LOCALE_ID, useValue: "en-NG" },
  { provide: NZ_I18N, useValue: LANG.zorro },
  { provide: NZ_DATE_LOCALE, useValue: LANG.date },
  { provide: DELON_LOCALE, useValue: LANG.delon },
];
// #endregion

// #region i18n services
import { I18NService, HttpCancelService } from "@core";
import { ALAIN_I18N_TOKEN } from "@delon/theme";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

// i18n
export function I18nHttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, `./assets/i18n/`, ".json");
}

const I18NSERVICE_MODULES = [
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: I18nHttpLoaderFactory,
      deps: [HttpClient],
    },
  }),
];

const I18NSERVICE_PROVIDES = [
  { provide: ALAIN_I18N_TOKEN, useClass: I18NService, multi: false },
];

// #region JSON Schema form (using @delon/form)
import { JsonSchemaModule } from "@shared";
const FORM_MODULES = [JsonSchemaModule];
// #endregion

// #region Http Interceptors
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { DefaultInterceptor } from "@core";
import { AUTH_DEFAULT_CONFIG, mergeConfig, provideAuth, withLocalStorage } from '@delon/auth';

const INTERCEPTOR_PROVIDES = [
  //{ provide: HTTP_INTERCEPTORS, useClass: HttpCancelService, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: DefaultInterceptor, multi: true },

  
];
// #endregion

// #region Startup Service
import { StartupService } from "@core";
export function StartupServiceFactory(
  startupService: StartupService
): () => Promise<void> {
  return () => startupService.load();
}
const APPINIT_PROVIDES = [
  StartupService,
  {
    provide: APP_INITIALIZER,
    useFactory: StartupServiceFactory,
    deps: [StartupService],
    multi: true,
  },
];
// #endregion

import { AppComponent } from "./app.component";
import { CoreModule } from "./core/core.module";
import { GlobalConfigModule } from "./global-config.module";
import { LayoutModule } from "./layout/layout.module";
import { RoutesModule } from "./routes/routes.module";
import { SharedModule } from "./shared/shared.module";

import { NgProgressModule } from "ngx-progressbar";
import {
  NG_PROGRESS_HTTP_CONFIG,
  NgProgressHttpModule,
} from "ngx-progressbar/http";
import { SimpleNotificationsModule } from "angular2-notifications";
import { environment } from "@env/environment";
import { ClipboardModule } from '@angular/cdk/clipboard';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha-angular19";

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        GlobalConfigModule.forRoot(),
        CoreModule,
        RecaptchaV3Module,
        SharedModule,
        LayoutModule,
        RoutesModule,
        ClipboardModule,
        NgProgressModule.withConfig({
            spinnerPosition: "left",
            color: "#008FB4",
        }),
        SimpleNotificationsModule.forRoot({
            position: ["top", "right"],
            timeOut: 20000,
            showProgressBar: true,
            pauseOnHover: true,
            preventDuplicates: true,
            clickToClose: true,
            maxLength: 2,
            maxStack: 2,
            theClass: "simple-notification-modal",
        }),
        NgProgressHttpModule.withConfig({
            silentApis: [
                `${environment.SERVER_URL}app-notifications/my-notifications`,
            ],
        }),
        ...I18NSERVICE_MODULES,
        // ...GLOBAL_THIRD_MODULES,
        ...FORM_MODULES], 
        providers: [
        ...LANG_PROVIDES,
        ...INTERCEPTOR_PROVIDES,
        ...I18NSERVICE_PROVIDES,
        ...APPINIT_PROVIDES,
        {
            provide: LocationStrategy, useClass: PathLocationStrategy
        },
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKey },
        provideAuth(withLocalStorage()),
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}
